export const baseUrl = 'https://hacker-news.firebaseio.com/v0';
